import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../LanguageContext";

function BTScanner() {
  const { t } = useLang();
  const showsItems = t("btScanner.showsItems");

  return (
    <div className="dev-page">
      <div className="page-section-header">
        <span className="section-label">{t("btScanner.label")}</span>
        <div className="subhead">{t("btScanner.title")}</div>
        <p className="section-intro-inner">{t("btScanner.intro")}</p>
      </div>

      <div className="showcase-layout">
        <div className="showcase-main">

          <div className="tool-card showcase-card">
            <h3>{t("btScanner.overviewTitle")}</h3>
            <p>{t("btScanner.overview1")}</p>
            <p>{t("btScanner.overview2")}</p>
          </div>

          <div className="tool-card showcase-card">
            <h3>{t("btScanner.showsTitle")}</h3>
            <ul className="showcase-list">
              {Array.isArray(showsItems) && showsItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

        </div>

        <div className="showcase-sidebar">
          <div className="tool-card showcase-links-card">
            <div className="showcase-app-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"/>
              </svg>
            </div>
            <h3>{t("btScanner.title")}</h3>
            <div className="project-tags" style={{marginBottom:"1.25rem"}}>
              <span className="tool-tag">React Native</span>
              <span className="tool-tag">iOS</span>
              <span className="tool-tag">BLE</span>
            </div>
            <div className="showcase-btn-col">
              <a href="https://apps.apple.com" target="_blank" rel="noreferrer" className="showcase-btn showcase-btn--primary">
                <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                {t("btScanner.appStore")}
              </a>
              <Link to="/btble-scanner/privacy" className="showcase-btn showcase-btn--outline">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                {t("btScanner.privacyPolicy")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BTScanner;
